import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useUserRatingsDetailListStyles = makeStyles({
    container: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        height: '100%',
        width: '100%',
        ...shorthands.overflow('hidden'),
    },
    summaryCard: {
        paddingTop: tokens.spacingVerticalL,
        paddingRight: tokens.spacingHorizontalL,
        paddingBottom: tokens.spacingVerticalL,
        paddingLeft: tokens.spacingHorizontalL,
        flexShrink: 0,
    },
    backButton: {
        flexShrink: 0,
    },
    header: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: tokens.spacingHorizontalM,
        marginBottom: tokens.spacingVerticalL,
    },
    title: {
        fontSize: tokens.fontSizeBase500,
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: tokens.spacingHorizontalL,
    },
    statItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
    },
    statLabel: {
        color: tokens.colorNeutralForeground3,
    },
    statValue: {
        fontWeight: tokens.fontWeightSemibold,
        color: tokens.colorNeutralForeground1,
    },
    ratingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
    ratingNumber: {
        fontWeight: tokens.fontWeightSemibold,
    },
    tableContainer: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.overflow('scroll'),
        backgroundColor: tokens.colorNeutralBackground1,
    },
    truncatedText: {
        ...shorthands.overflow('hidden'),
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '200px',
    },
    expandedText: {
        whiteSpace: 'normal',
        wordBreak: 'break-word',
    },
    commentCell: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalXS,
        alignItems: 'flex-start',
        width: '100%',
    },
    expandButton: {
        minHeight: '24px',
        paddingTop: tokens.spacingVerticalXXS,
        paddingBottom: tokens.spacingVerticalXXS,
        fontSize: tokens.fontSizeBase200,
    },
    centerContent: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
        minHeight: '200px',
        flex: 1,
    },
    errorContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: tokens.spacingVerticalM,
    },
    tableRow: {
        cursor: 'pointer',
        ':hover': {
            backgroundColor: tokens.colorNeutralBackground1Hover,
        },
    },
});